/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';

export const jiraIssueTypeSchema = z.object({
  hierarchyLevel: z.int(),
  id: z.string(),
  name: z.string(),
});
